import { quoteLineType } from '../../types'
import { BundleLineItem } from './lineItemPricing'

export type FlatRenderItem = {
  item: quoteLineType
  bundleId: string | null
  isHeader: boolean
}

export function toFlatRenderItems(items: Array<quoteLineType & { children?: quoteLineType[] }>): FlatRenderItem[] {
  const result: FlatRenderItem[] = []
  items.forEach(item => {
    if (item.LineNumber === -1) {
      result.push({ item, bundleId: item.Bundle || null, isHeader: true })
      item.children?.forEach(lineItem => {
        result.push({ item: lineItem, bundleId: item.Bundle || null, isHeader: false })
      })
    } else {
      result.push({ item, bundleId: null, isHeader: false })
    }
  })
  return result
}

export function isLastChildInBundle(lineItems: BundleLineItem[], renderItem: FlatRenderItem) {
  if (renderItem.isHeader || renderItem.bundleId === null) return false
  const fullBundle = lineItems.find(item => item.Bundle === renderItem.bundleId && item.LineNumber === -1)
  if (!fullBundle?.children?.length) return false
  return fullBundle.children[fullBundle.children.length - 1].LineItemId === renderItem.item.LineItemId
}
